import { Component, OnInit, Output, EventEmitter, ViewEncapsulation, Input } from '@angular/core';
import { Catalog } from 'src/app/models/catalog';
import { CatalogService } from 'src/app/core/services/catalog.service';
import { SvFilesChanged, CheckboxListItem, SvNotificationStatus, CheckboxItem } from 'sv-chemistry-ng-lib';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { SvNotification, PageLevelNotificationService } from 'src/app/core/services/page-level-notification.service';
import { Retailer } from 'src/app/models/Retailer';
import { UserInfoService } from 'src/app/core/services/user-info.service';
import { Store } from 'src/app/models/store';
import { environment } from 'src/environments/environment';


export const testRadios = [
  {
    value: 1,
    display: "sort by number"
  },
  {
    value: 2,
    display: "sort by name"
  }
];
export const selectRadios =[
{
  value:3,
  display: "Select All"
},
{
  value:4,
  display: "Deselect All"
}];


@Component({
  selector: 'catalog-table',
  templateUrl: './catalog-table.component.html',
  styleUrls: ['./catalog-table.component.scss'],
  encapsulation: ViewEncapsulation.None

})

export class CatalogTableComponent implements OnInit {
  userNotFound = false;
  isSessionTimeOut = false;

  @Output() showPopupValue = new EventEmitter<boolean>();
  term: any;
  isSelectAllSelected: boolean = false;
  showNoStoreErrorMessage: boolean = false;
  noStoreErrorMessage: string = "";

  validFiles: File[];
  invalidFiles: File[];

  acceptsMultiple: boolean = false;
  acceptedTypes: string[] = [".dat"];
  file: File[];

  races = [];
  selectDeselectValues = [];
  selectedRace: string;
  selectedValue:string;
  sortedCheckboxes: CheckboxListItem[] = [];
  public showAssignStore: boolean = false;
  public showLoading: boolean = false;
  message: string;
  errorMessageArray: any[] = [];
  svgs: string[] = ["home", "home-filled", "icn-check-circle-filled", "icn-exclamation-circle", "icn-exclamation-circle-filled",
    "icn-info-circle-filled", "arrow-drop-down", "arrow-drop-up", "search", "sort", "help-outline",
    "chevron-left", "chevron-right", "arrow-left", "arrow-right", "first-page", "last-page", "sort-down", "sort-up",
    "left-unfilled-arrow", "down-unfilled-arrow", "search-magnifying", "x-times", "question-mark", "question-mark-hover",
    "check-circle-filled", "exclamation-circle-filled", "exclamation-circle", "info-circle-filled", "calendar-full",
    "trash-can", "trash-can-filled", "plus-circle-filled"
  ];

  selectedRetailCompany: Retailer = null;

  constructor(private _userService: UserInfoService, private _catalogService: CatalogService, //private _fb: FormBuilder, 
    private router: Router,
    private _pageNotificationService: PageLevelNotificationService) {
    testRadios.map((item) => {
      this.races.push({
        display: item.display,
        value: item.value
      })
    });
    selectRadios.map((data) => {
      this.selectDeselectValues.push({
        display: data.display,
        value: data.value
      })
    });
    this.selectedRace = this.races[0].value;

    this.sortValuesBy(this.selectedRace);
  }


  ngOnInit() {
    this._userService.selectedRetailCompany$.subscribe(
      rc => {
        this.selectedRetailCompany = rc;
        if (this.selectedRetailCompany && this.selectedRetailCompany != null) {
          this.createCheckBoxesForStores(this.selectedRetailCompany.stores);
        }
      },
      error => {
        this.showPageErrorNotification(error, "We are experiencing an error while retrieving the selected retail company");
     });
  }

  public displayVendorsClicked(e, theCatalog: Catalog): void {
    console.log("displayVendors: " + theCatalog.name);
    console.log("number of vendors: " + theCatalog.vendors.length);
  }

  newFunction = function () {
    this.showModal = true;
    console.log("test", this.showModal);
  }

  filesChanged(evt: SvFilesChanged) {
    if(this._userService.isTimeout()) {
      this.userNotFound = true;
      this.isSessionTimeOut = true;
    } else { 
      this.showAssignStore = false;
      this.validFiles = evt.validFiles;
      this.invalidFiles = evt.invalidFiles;
  
      if (this.validFiles.length !== 0) {
        this.file = this.validFiles;
        this.showAssignStore = true;
      }
      else {
        this._pageNotificationService.showNotification(new SvNotification(SvNotificationStatus.Error, "We were not able to upload your catalog.  File type must be .dat"));
      }
    } 
  }


  sortValuesBy(value) {
    if (value == 1) {
      this.sortedCheckboxes.sort(function (a, b) {
        if (a.data['data']['store_number'] < b.data['data']['store_number']) { return -1; }
        if (a.data['data']['store_number'] > b.data['data']['store_number']) { return 1; }
        return 0;
      })
    }
    else {
      this.sortedCheckboxes.sort(function (a, b) {
        if (a.data['data']['store_name'] < b.data['data']['store_name']) { return -1; }
        if (a.data['data']['store_name'] > b.data['data']['store_name']) { return 1; }
        return 0;
      })
    }
  }

  clickAddStores() {
    if(this._userService.isTimeout()) {
      this.userNotFound = true;
      this.isSessionTimeOut = true;
    } else { 
      this.errorMessageArray = [];
      var storeSelectedArray: any = [];
      let badVendorArray :string[] = [];
   
      for (let i = 0; i < this.sortedCheckboxes.length; i++) {
        if (this.sortedCheckboxes[i].data.isSelected == true) {
          var storeSelected = this.sortedCheckboxes[i].data.data['store_number'];
          storeSelectedArray.push(storeSelected);
        }
      }
  
      if (storeSelectedArray.length !== 0) {
        this.showLoading = true;
        this.showAssignStore = false;
        this._catalogService.assignStore(this.file[0], this.selectedRetailCompany.retailerId, storeSelectedArray).subscribe(data => {
          {
            for (let q = 0; q < data['errors'].length; q++) {
              let currentError: string = data['errors'][q]['details'];
              if(currentError.indexOf("The vendor") == 0) {
                let currentVendor : string = currentError.substr(10,currentError.indexOf("is not")-11);
                if(badVendorArray.indexOf(currentVendor) == -1) {
                  var arrayMessage = '<b>Unauthorized Vendor: </b>' + currentVendor +' is not authorized to the retailer' + "<br>";
                  this.errorMessageArray.push(arrayMessage);
                  badVendorArray.push(currentVendor);
                }
  
              }
              else {
                var arrayMessage = '<b>Line ' + data['errors'][q].lineNumber + ':</b> ' + data['errors'][q].details + "<br>";
                this.errorMessageArray.push(arrayMessage);
              }
            }
          }
  
          // this._catalogService.success('Catalog was successfully uploaded');
          // setTimeout(() => {
            if (data['message'] === 'Catalog successfully uploaded') {
              if (this.errorMessageArray.length == 0) {
                this.showLoading = false;
                this.showPageSuccessNotification();
              }
              else {
                this.showLoading = false;
                this.showErrorValidationNotification("Your catalog was partially uploaded. It contains " + this.errorMessageArray.length + " errors:<br>");
              }
            }
            else {
              this.showLoading = false;
              this.showErrorValidationNotification("Your catalog was not uploaded because it contains " + this.errorMessageArray.length + " errors:<br>");
            }
          // }, 2000);
        },
        error => {
          //this._catalogService.error(error);
          this.showPageErrorNotification(error, "We are recieving an error while assigning stores.  Please try again.");
        });
      }
      else {
        this.noStoreErrorMessage = "Please select at least one store to assign.";
        this.showNoStoreErrorMessage = true;
      }
    }
  }

  assignSelectedStores() {
    this.showAssignStore = false;
  }

  showErrorValidationNotification(message: string) {
    let errorMessageString: string = "";
    for (let i = 0; i < this.errorMessageArray.length; i++) {
      errorMessageString += this.errorMessageArray[i];
    }
    this._pageNotificationService.showNotification(new SvNotification(SvNotificationStatus.Error, message + errorMessageString));
  }

  showPageSuccessNotification() {
    this.showLoading = false;
    this.showAssignStore = false;
    this._pageNotificationService.showNotification(new SvNotification(SvNotificationStatus.Confirmation, "Your catalog was successfully uploaded."));
  }


  createCheckBoxesForStores(stores: Store[]) {
    this.sortedCheckboxes = [];
    stores.forEach(store => {
      this.sortedCheckboxes.push({
        isDisabled: false,
        isCheckboxRight: false,
        label: store.storeId + " " + store.storeName,
        data: new CheckboxItem(false, {
          store_number: store.storeId,
          store_name: store.storeName
        })
      })
    });
  }


  selectandDeselectValues(value){
    if(value == 3){
      for(let i=0;i<this.sortedCheckboxes.length;i++){
        this.sortedCheckboxes[i]['data'].isSelected = true;
        console.log('select',this.sortedCheckboxes);
      }
    }
    else{
      for(let i=0;i<this.sortedCheckboxes.length;i++){
        this.sortedCheckboxes[i]['data'].isSelected = false;
        console.log('deselect');
      }
    }
  }


  returnToLogin() {
    window.location.href = environment.guardLoginUrl;
  }

  closeAssignStores() {
    this.showAssignStore = false;
  }


  showPageErrorNotification(error : any, genericeMessage : string = null) {
    console.log(error);
      let errorMessage = null;
      if(error._body) {
        let returnedError = JSON.parse(error._body);
        errorMessage = returnedError.details;
      } else if(error.error) {
        errorMessage = error.error.details + ". " + error.error.message;
      }else if(error.status == 401) {
        this.userNotFound = true; 
      } else {
        errorMessage = genericeMessage != null ? genericeMessage : "We are experiencing catalog issues.. Please try again.";
      }
      if(errorMessage != null) {
        this._pageNotificationService.showNotification(new SvNotification(SvNotificationStatus.Error,errorMessage ));     
      }
    }

}

